import exportReducer from "./reducers";

export default exportReducer;